// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/Group 103.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overall Container */
.home-container {
  display: flex;
  flex-direction: row;
}

/* Navbar Styles */
.navbar {
  background: #3786C6;
  width: 260px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  position: fixed;
}




.navbar .navbar-brand {
  margin-bottom: 20px;
  font-size: 1.5rem;
  color: white;
}

.navbar .navbar-nav {
  width: 100%;
  flex-direction: column;
}

.navbar .nav-item {
  margin-bottom: 10px;
  position: relative;
}


.dropdown-item.active {
  background-color: var(--Dark-blue, #032845);
  color: white;
}
.navbar .nav-link.active {
  background: var(--Dark-blue, #032845);
  color: white;
  font-weight: bold; /* Additional style for testing */
}


.navbar .nav-link {
  color: white;
  font-size: 1.0rem;
  padding: 10px 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: start;
 
}

.navbar .nav-link .icon {
  margin-right: 10px;
}

.navbar .text-white {
  color: white;
  cursor: pointer;
}

.dropdown-toggle::after {
  display: none;
}

.icon {
  font-size: 1.2rem;
}

.search {
  padding-left: 5px;
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #3786C6;
 border: none;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
  padding: 0;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-item {
  color: white;
  padding: 0.5rem 1rem;
  text-decoration: none;
  display: block;
}

.logout {
  text-decoration: none;
  color: white;
  font-size: 16px;
  padding: 10px 8px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: start;
  margin-right: 10px;
}


/* Content Styles */
.content {
  margin-left: 260px;
  padding: 20px;
  flex: 1 1;
  background-color: #f5f5f5;
  min-height: 100vh;
  box-sizing: border-box;
}

.page-background {
  background-color: #f5f5f5;
}

.dashboard {
  padding-left: 10px;
}

.custom-table {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.table-primary {
  background-color: #007bff;
  color: white;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

.bg-light {
  background-color: #f9f9f9 !important;
}

.my-4 {
  margin-left: 20px;
}

.add-user {
  background-color: #3786C6;
}
.bulk-upload{
  
  background-color: #3786C6;
}

.card-active-users {
  background: linear-gradient(to right,  #34C759 7%, white 7%);
  border: none;
  box-shadow: none;
  width: 100%;
  max-width: 305px;
  height: 100%;
 
}

.card-inactive-users {
  background: linear-gradient(to right, #FF3B30 7%, white 7%);
  border: none;
  box-shadow: none;
  width: 100%;
  max-width: 305px;
  height: 100%;
  

}

.last-update {
  font-size: 10px;
  align-items: center;
  padding-left: 10px;
}

.modal-custom {
  max-width: 700px;
}

.modal-body {
  padding-left: 35px;
  padding-right: 35px;
}

.modal-header-center {
  text-align: center;
}


/* Animation for rotating elements */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}

.rotating {
  animation: rotate 1s linear infinite;
}

/* Login Styles */
.login-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  background-color: #fff;
  padding: 60px;
 
  border-radius: 10px;
 
  max-width: 600px;
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-control {

  border: 1px solid #ccc;
}
.back-to-login {
  display: block;
  text-align: center;
  margin-top: 20px;
  text-decoration: none;

  
}

.back-to-login:hover {
  text-decoration: none;
}

.back-to-login .me-2 {
  margin-right: 8px; 
}



/* Custom button styles for user actions */
.btn-user {
  color: black;
  
  border: 1px solid black;
 
  cursor: pointer;
}

/* Specific styles for the outline-light variant */
.btn-outline-light.btn-user {
  border-color: black !important; 
  color: black !important; 
  background-color: transparent;
}

.btn-outline-light.btn-user:hover {
  background-color: rgba(0, 0, 0, 0.1); 
}

.btn-outline-light.btn-user:disabled {
  border-color: #6c757d !important; 
  color: #6c757d !important;
}


.btn-manual {
  background: #3786C6;
  color: white;
  border: 1px solid white;
  padding: 10px 20px;
}

.btn-manual:hover {
  background: #3786C6;
}

.navbar-nav .dropdown-menu {
  position: absolute;
}


thead th {
  position: relative;
}

thead th svg {
  margin-left: 5px;
  font-size: 12px;
  vertical-align: middle;
}

.yelloBg{
  background-color: yellow;
}
/* Media Queries */
@media (max-width: 768px) {
  .navbar {
    width: 100%;
    height: auto;
    position: relative;
  }

  .navbar .navbar-brand {
    margin-bottom: 10px;
  }

  .navbar .navbar-nav {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .navbar .nav-item {
    margin-bottom: 0;
    flex: 1 1 50%;
  }

  .navbar .nav-link {
    padding: 10px 15px;
    justify-content: flex-start;
  }

  .content {
    margin-left: 0;
    padding: 20px;
  }

  .table-responsive {
    overflow-x: auto;
  }

  .custom-table {
    border-radius: 0;
  }

  .my-4 {
    margin-left: 0;
  }

  .dropdown-menu {
    display: none;
    width: 100%;
  }

  .dropdown-menu.show {
    display: block;
  }
  .justify-content-md-end {
    justify-content: center !important;
  }
}

@media (max-width: 576px) {
  .navbar .navbar-brand {
    font-size: 1.2rem;
  }

  .navbar .nav-link {
    font-size: 1rem;
    padding: 8px 12px;
  }

  .card-active-users, .card-inactive-users {
    width: 100%;
  }

  .modal-custom {
    max-width: 90%;
    margin: 0 auto;
  }

  .login-box {
    padding: 40px;
    width: 100%;
    max-width: 300px;
  }
  .justify-content-md-end {
    justify-content: flex-start !important;
    
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Style.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;;;;AAKA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,2CAA2C;EAC3C,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,YAAY;EACZ,iBAAiB,EAAE,iCAAiC;AACtD;;;AAGA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;;AAExB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;CAC1B,YAAY;EACX,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,2DAA2D;EAC3D,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;;;AAGd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA,oCAAoC;AACpC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,yDAAgD;EAChD,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;;EAEb,mBAAmB;;EAEnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;;;AAGvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;;;AAIA,0CAA0C;AAC1C;EACE,YAAY;;EAEZ,uBAAuB;;EAEvB,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;AACA,kBAAkB;AAClB;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,sCAAsC;;EAExC;AACF","sourcesContent":["/* Overall Container */\n.home-container {\n  display: flex;\n  flex-direction: row;\n}\n\n/* Navbar Styles */\n.navbar {\n  background: #3786C6;\n  width: 260px;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  box-sizing: border-box;\n  position: fixed;\n}\n\n\n\n\n.navbar .navbar-brand {\n  margin-bottom: 20px;\n  font-size: 1.5rem;\n  color: white;\n}\n\n.navbar .navbar-nav {\n  width: 100%;\n  flex-direction: column;\n}\n\n.navbar .nav-item {\n  margin-bottom: 10px;\n  position: relative;\n}\n\n\n.dropdown-item.active {\n  background-color: var(--Dark-blue, #032845);\n  color: white;\n}\n.navbar .nav-link.active {\n  background: var(--Dark-blue, #032845);\n  color: white;\n  font-weight: bold; /* Additional style for testing */\n}\n\n\n.navbar .nav-link {\n  color: white;\n  font-size: 1.0rem;\n  padding: 10px 15px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n \n}\n\n.navbar .nav-link .icon {\n  margin-right: 10px;\n}\n\n.navbar .text-white {\n  color: white;\n  cursor: pointer;\n}\n\n.dropdown-toggle::after {\n  display: none;\n}\n\n.icon {\n  font-size: 1.2rem;\n}\n\n.search {\n  padding-left: 5px;\n}\n\n.dropdown-menu {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  background-color: #3786C6;\n border: none;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  min-width: 200px;\n  z-index: 1000;\n  padding: 0;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-item {\n  color: white;\n  padding: 0.5rem 1rem;\n  text-decoration: none;\n  display: block;\n}\n\n.logout {\n  text-decoration: none;\n  color: white;\n  font-size: 16px;\n  padding: 10px 8px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  margin-right: 10px;\n}\n\n\n/* Content Styles */\n.content {\n  margin-left: 260px;\n  padding: 20px;\n  flex: 1;\n  background-color: #f5f5f5;\n  min-height: 100vh;\n  box-sizing: border-box;\n}\n\n.page-background {\n  background-color: #f5f5f5;\n}\n\n.dashboard {\n  padding-left: 10px;\n}\n\n.custom-table {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-top: 20px;\n}\n\n.table-primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.table-hover tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n.bg-light {\n  background-color: #f9f9f9 !important;\n}\n\n.my-4 {\n  margin-left: 20px;\n}\n\n.add-user {\n  background-color: #3786C6;\n}\n.bulk-upload{\n  \n  background-color: #3786C6;\n}\n\n.card-active-users {\n  background: linear-gradient(to right,  #34C759 7%, white 7%);\n  border: none;\n  box-shadow: none;\n  width: 100%;\n  max-width: 305px;\n  height: 100%;\n \n}\n\n.card-inactive-users {\n  background: linear-gradient(to right, #FF3B30 7%, white 7%);\n  border: none;\n  box-shadow: none;\n  width: 100%;\n  max-width: 305px;\n  height: 100%;\n  \n\n}\n\n.last-update {\n  font-size: 10px;\n  align-items: center;\n  padding-left: 10px;\n}\n\n.modal-custom {\n  max-width: 700px;\n}\n\n.modal-body {\n  padding-left: 35px;\n  padding-right: 35px;\n}\n\n.modal-header-center {\n  text-align: center;\n}\n\n\n/* Animation for rotating elements */\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(-360deg);\n  }\n}\n\n.rotating {\n  animation: rotate 1s linear infinite;\n}\n\n/* Login Styles */\n.login-container {\n  background-image: url('./images/Group\\ 103.jpg');\n  background-size: cover;\n  background-position: center;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-box {\n  background-color: #fff;\n  padding: 60px;\n \n  border-radius: 10px;\n \n  max-width: 600px;\n  width: 100%;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-control {\n\n  border: 1px solid #ccc;\n}\n.back-to-login {\n  display: block;\n  text-align: center;\n  margin-top: 20px;\n  text-decoration: none;\n\n  \n}\n\n.back-to-login:hover {\n  text-decoration: none;\n}\n\n.back-to-login .me-2 {\n  margin-right: 8px; \n}\n\n\n\n/* Custom button styles for user actions */\n.btn-user {\n  color: black;\n  \n  border: 1px solid black;\n \n  cursor: pointer;\n}\n\n/* Specific styles for the outline-light variant */\n.btn-outline-light.btn-user {\n  border-color: black !important; \n  color: black !important; \n  background-color: transparent;\n}\n\n.btn-outline-light.btn-user:hover {\n  background-color: rgba(0, 0, 0, 0.1); \n}\n\n.btn-outline-light.btn-user:disabled {\n  border-color: #6c757d !important; \n  color: #6c757d !important;\n}\n\n\n.btn-manual {\n  background: #3786C6;\n  color: white;\n  border: 1px solid white;\n  padding: 10px 20px;\n}\n\n.btn-manual:hover {\n  background: #3786C6;\n}\n\n.navbar-nav .dropdown-menu {\n  position: absolute;\n}\n\n\nthead th {\n  position: relative;\n}\n\nthead th svg {\n  margin-left: 5px;\n  font-size: 12px;\n  vertical-align: middle;\n}\n\n.yelloBg{\n  background-color: yellow;\n}\n/* Media Queries */\n@media (max-width: 768px) {\n  .navbar {\n    width: 100%;\n    height: auto;\n    position: relative;\n  }\n\n  .navbar .navbar-brand {\n    margin-bottom: 10px;\n  }\n\n  .navbar .navbar-nav {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .navbar .nav-item {\n    margin-bottom: 0;\n    flex: 1 1 50%;\n  }\n\n  .navbar .nav-link {\n    padding: 10px 15px;\n    justify-content: flex-start;\n  }\n\n  .content {\n    margin-left: 0;\n    padding: 20px;\n  }\n\n  .table-responsive {\n    overflow-x: auto;\n  }\n\n  .custom-table {\n    border-radius: 0;\n  }\n\n  .my-4 {\n    margin-left: 0;\n  }\n\n  .dropdown-menu {\n    display: none;\n    width: 100%;\n  }\n\n  .dropdown-menu.show {\n    display: block;\n  }\n  .justify-content-md-end {\n    justify-content: center !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .navbar .navbar-brand {\n    font-size: 1.2rem;\n  }\n\n  .navbar .nav-link {\n    font-size: 1rem;\n    padding: 8px 12px;\n  }\n\n  .card-active-users, .card-inactive-users {\n    width: 100%;\n  }\n\n  .modal-custom {\n    max-width: 90%;\n    margin: 0 auto;\n  }\n\n  .login-box {\n    padding: 40px;\n    width: 100%;\n    max-width: 300px;\n  }\n  .justify-content-md-end {\n    justify-content: flex-start !important;\n    \n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
